module.exports = __webpack_public_path__ + "img/29_28.dc75cb76.png";